export default __webpack_public_path__ + "static/media/CNo.60-3.90ac7747.jpg";